import PropTypes from 'prop-types';
import { t } from 'bv-i18n';
import { Balance, LazyUserInboxIcon } from 'Index/features/layout/components/header/components';
import { Button, Link } from 'bv-components';
import { getCookie } from 'bv';
import { useQuickDepositLink } from 'bv-hooks';

const UserDetailsView = ({ loggedIn, showKycBanner }) => {
  const everLoggedIn = getCookie('ever_logged_in') && JSON.parse(getCookie('ever_logged_in'));
  const depositHref = useQuickDepositLink();

  return (
    <div className="site-header__user-details">
      {loggedIn ? (
        <>
          <LazyUserInboxIcon />
          <Balance />
          <Button
            href={depositHref}
            className="buttons__login_bar--account-deposit"
            label={t('deposit')}
            primary
          />
          <Link
            to="/bv_cashier/overview"
            className={`site-header__my-account${showKycBanner ? ' is-unverified' : ''}`}
          />
        </>
      ) : (
        <>
          <Button to="/login" primary={everLoggedIn} className="buttons__login_bar--login">
            {t('login')}
          </Button>
          <Button to="/account/new" primary={!everLoggedIn} className="buttons__login_bar--create-account">
            {t('open_account')}
          </Button>
        </>
      )}
    </div>
  );
};

UserDetailsView.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  showKycBanner: PropTypes.bool.isRequired,
};

export default UserDetailsView;
